/* eslint-disable max-lines */
import React from 'react';
import { Button, Tag } from 'src/@vymo/ui/atoms';
import { ReactComponent as DocumentDownload } from 'src/assets/icons/document-download.svg';
import { Keys } from 'src/i18n';
// eslint-disable-next-line vymo-ui/restrict-import
import {
  BULK_ALLOCATION,
  BULK_REVOCATION,
  CRM_UPDATE_STATUS,
  WORKFLOW_DDP_STATUS,
} from '../constants';
// eslint-disable-next-line vymo-ui/restrict-import
import { BASE_URL } from '../revyre/thunk';
import { formatReadableDate } from './queries';
import { ModuleConfig } from './types';

const statusVariantMap = {
  EXPIRED: 'default',
  RUNNING: 'info',
  CANCELLED: 'warning',
  ERRORED: 'error',
  COMPLETED: 'success',
  ERROR: 'error',
};

const ddpJobDetailsColumnConfig = [
  {
    disabled: false,
    order: null,
    code: 'id',
    export: true,
    filter: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    input: {
      code: 'id',
      type: 'text',
      required: false,
      source: null,
      hint: 'Job Id',
      placeholder: null,
      invisible: false,
      hidden: false,
      regex: null,
      oif_options: null,
      default_value: null,
      read_only: false,
      min_chars: null,
      max_chars: null,
      regex_hint: null,
    },
    name: 'Job Id',
    required: false,
    search: false,
    title: 'Job Id',
    visible: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    sortable: null,
    sources: null,
    entity: null,
  },
  {
    disabled: false,
    order: null,
    code: 'jobDescription',
    export: true,
    filter: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    input: {
      code: 'jobDescription',
      type: 'text',
      required: false,
      source: null,
      hint: 'Job Type',
      placeholder: null,
      invisible: false,
      hidden: false,
      regex: null,
      oif_options: null,
      default_value: null,
      read_only: false,
      min_chars: null,
      max_chars: null,
      regex_hint: null,
    },
    name: 'Job Type',
    required: false,
    search: false,
    title: 'Job Type',
    visible: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    sortable: null,
    sources: null,
    entity: null,
  },
  {
    disabled: false,
    order: null,
    code: 'receivedDate',
    export: true,
    filter: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    input: {
      code: 'receivedDate',
      type: 'date',
      required: false,
      source: null,
      hint: 'Received Date',
      placeholder: null,
      invisible: false,
      hidden: false,
      regex: null,
      oif_options: null,
      default_value: null,
      read_only: false,
      min_chars: null,
      max_chars: null,
      regex_hint: null,
    },
    name: 'Received Date',
    required: false,
    search: false,
    title: 'Received Date',
    visible: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    sortable: null,
    sources: null,
    entity: null,
    cell: (value) => formatReadableDate(value),
  },
  {
    disabled: false,
    order: null,
    code: 'availableTill',
    export: true,
    filter: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    input: {
      code: 'availableTill',
      type: 'date',
      required: false,
      source: null,
      hint: 'Available Till',
      placeholder: null,
      invisible: false,
      hidden: false,
      regex: null,
      oif_options: null,
      default_value: null,
      read_only: false,
      min_chars: null,
      max_chars: null,
      regex_hint: null,
    },
    name: 'Available Till',
    required: false,
    search: false,
    title: 'Available Till',
    visible: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    sortable: null,
    sources: null,
    entity: null,
    cell: (value) => formatReadableDate(value),
  },
  {
    disabled: false,
    order: null,
    code: 'module',
    export: true,
    filter: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    input: {
      code: 'module',
      type: 'text',
      required: false,
      source: null,
      hint: 'Module',
      placeholder: null,
      invisible: false,
      hidden: false,
      regex: null,
      oif_options: null,
      default_value: null,
      read_only: false,
      min_chars: null,
      max_chars: null,
      regex_hint: null,
    },
    name: 'Module',
    required: false,
    search: false,
    title: 'Module',
    visible: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    sortable: null,
    sources: null,
    entity: null,
  },
  {
    disabled: false,
    order: null,
    code: 'userCode',
    export: true,
    filter: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    input: {
      code: 'userCode',
      type: 'text',
      required: false,
      source: null,
      hint: 'Initiated By',
      placeholder: null,
      invisible: false,
      hidden: false,
      regex: null,
      oif_options: null,
      default_value: null,
      read_only: false,
      min_chars: null,
      max_chars: null,
      regex_hint: null,
    },
    name: 'Initiated By',
    required: false,
    search: false,
    title: 'Initiated By',
    visible: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    sortable: null,
    sources: null,
    entity: null,
  },
  {
    disabled: false,
    order: null,
    code: 'status',
    export: true,
    filter: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    input: {
      code: 'status',
      type: 'text',
      required: false,
      source: null,
      hint: 'Status',
      placeholder: null,
      invisible: false,
      hidden: false,
      regex: null,
      oif_options: null,
      default_value: null,
      read_only: false,
      min_chars: null,
      max_chars: null,
      regex_hint: null,
    },
    name: 'Status',
    required: false,
    search: false,
    title: 'Status',
    visible: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    sortable: null,
    sources: null,
    entity: null,
    cell: (value) => (
      <Tag
        label={value}
        variant={statusVariantMap[value?.split(' ')?.[0]?.toUpperCase()]}
      />
    ),
  },
  {
    disabled: false,
    order: null,
    code: 'downloadLink',
    export: true,
    filter: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    name: 'Link',
    required: false,
    search: false,
    title: 'Link',
    visible: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    sortable: null,
    sources: null,
    entity: null,
    cell: (value) => {
      if (!value) {
        return null;
      }
      return (
        <Button
          onClick={(e) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            e.stopPropagation();
            try {
              const link = document.createElement('a');
              link.href = value;
              link.download = '';
              link.rel = 'noopener noreferrer';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } catch (error) {
              // eslint-disable-next-line no-console
              console.log(error);
            }
          }}
          type="text"
          rounded
          isIcon
          size="small"
          iconProps={{
            icon: <DocumentDownload />,
            iconPosition: 'left',
          }}
        />
      );
    },
  },
];

const workflowUploadsJobDetailsColumnConfig = [
  {
    disabled: false,
    order: null,
    code: 'jobId',
    export: true,
    filter: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    input: {
      code: 'jobId',
      type: 'text',
      required: false,
      source: null,
      hint: 'Job Id',
      placeholder: null,
      invisible: false,
      hidden: false,
      regex: null,
      oif_options: null,
      default_value: null,
      read_only: false,
      min_chars: null,
      max_chars: null,
      regex_hint: null,
    },
    name: 'Job Id',
    required: false,
    search: false,
    title: 'Job Id',
    visible: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    sortable: null,
    sources: null,
    entity: null,
  },
  {
    disabled: false,
    order: null,
    code: 'jobType',
    export: true,
    filter: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    input: {
      code: 'jobType',
      type: 'text',
      required: false,
      source: null,
      hint: 'Job Type',
      placeholder: null,
      invisible: false,
      hidden: false,
      regex: null,
      oif_options: null,
      default_value: null,
      read_only: false,
      min_chars: null,
      max_chars: null,
      regex_hint: null,
    },
    name: 'Job Type',
    required: false,
    search: false,
    title: 'Job Type',
    visible: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    sortable: null,
    sources: null,
    entity: null,
  },
  {
    disabled: false,
    order: null,
    code: 'status',
    export: true,
    filter: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    input: {
      code: 'status',
      type: 'text',
      required: false,
      source: null,
      hint: 'Status',
      placeholder: null,
      invisible: false,
      hidden: false,
      regex: null,
      oif_options: null,
      default_value: null,
      read_only: false,
      min_chars: null,
      max_chars: null,
      regex_hint: null,
    },
    name: 'Status',
    required: false,
    search: false,
    title: 'Status',
    visible: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    sortable: null,
    sources: null,
    entity: null,
    cell: (value) => (
      <Tag
        label={value}
        variant={statusVariantMap[value?.split(' ')?.[0]?.toUpperCase()]}
      />
    ),
  },
  {
    disabled: false,
    order: null,
    code: 'initiatedBy',
    export: true,
    filter: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    input: {
      code: 'initiatedBy',
      type: 'text',
      required: false,
      source: null,
      hint: 'Initiated By',
      placeholder: null,
      invisible: false,
      hidden: false,
      regex: null,
      oif_options: null,
      default_value: null,
      read_only: false,
      min_chars: null,
      max_chars: null,
      regex_hint: null,
    },
    name: 'Initiated By',
    required: false,
    search: false,
    title: 'Initiated By',
    visible: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    sortable: null,
    sources: null,
    entity: null,
  },
  {
    disabled: false,
    order: null,
    code: 'createdTime',
    export: true,
    filter: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    input: {
      code: 'createdTime',
      type: 'date',
      required: false,
      source: null,
      hint: 'Created Time',
      placeholder: null,
      invisible: false,
      hidden: false,
      regex: null,
      oif_options: null,
      default_value: null,
      read_only: false,
      min_chars: null,
      max_chars: null,
      regex_hint: null,
    },
    name: 'Created Time',
    required: false,
    search: false,
    title: 'Created Time',
    visible: {
      enabledFor: ['web', 'app'],
      locale: null,
    },
    sortable: null,
    sources: null,
    entity: null,
    cell: (value) => formatReadableDate(value),
  },
];

export const moduleConfigs: Record<string, ModuleConfig> = {
  [WORKFLOW_DDP_STATUS]: {
    url: `${BASE_URL}/jobs/list`,
    getPayload: (basePayload) => ({
      page: basePayload.page_number - 1,
      size: basePayload.page_size,
      sortBy: 'createdAt',
      sortDirection: 'DESC',
      jobTypes: [2],
    }),
    rowsKey: 'jobs',
    columns: ddpJobDetailsColumnConfig,
    errorKey: Keys.ERROR_FETCHING_LIST_DATA,
    getData: (responseData) => responseData?.payload,
  },
  [BULK_ALLOCATION]: {
    url: `${BASE_URL}/bulk-allocation/list`,
    getPayload: (basePayload) => ({
      page: {
        pageSize: basePayload.page_size,
        pageNumber: basePayload.page_number,
      },
    }),
    rowsKey: 'result',
    columns: workflowUploadsJobDetailsColumnConfig,
    errorKey: Keys.ERROR_FETCHING_LIST_DATA,
    getData: (responseData) => responseData?.payload,
    getMetadata: (data, pageSize, currentPage) => ({
      totalCount: data?.totalCount,
      maxPages: data?.maxPages,
      pageSize,
      currentPage: data?.currentPage || currentPage,
    }),
  },
  [BULK_REVOCATION]: {
    url: `${BASE_URL}/bulk-revocation/list`,
    getPayload: (basePayload) => ({
      page: {
        pageSize: basePayload.page_size,
        pageNumber: basePayload.page_number,
      },
    }),
    rowsKey: 'result',
    columns: workflowUploadsJobDetailsColumnConfig,
    errorKey: Keys.ERROR_FETCHING_LIST_DATA,
    getData: (responseData) => responseData?.payload,
    getMetadata: (data, pageSize, currentPage) => ({
      totalCount: data?.totalCount,
      maxPages: data?.maxPages,
      pageSize,
      currentPage: data?.currentPage || currentPage,
    }),
  },
  [CRM_UPDATE_STATUS]: {
    url: `${BASE_URL}/audit/api-log-records/list`,
    configUrl: `${BASE_URL}/api-log-records/config`,
    getPayload: (basePayload) => ({
      filters: basePayload?.filters,
      module: basePayload?.module,
      page: {
        pageSize: basePayload.page_size,
        pageNumber: basePayload.page_number,
      },
    }),
    getData: (responseData) => responseData?.payload,
    rowsKey: 'result',
    errorKey: Keys.ERROR_FETCHING_LIST_DATA,
    getMetadata: (data, pageSize, currentPage) => ({
      totalCount: data?.totalCount,
      maxPages: data?.maxPages,
      pageSize,
      currentPage: data?.currentPage || currentPage,
    }),
  },
  tasks: {
    url: '/cs/web/calendar-items',
    rowsKey: 'results',
    errorKey: Keys.ERROR_FETCHING_CONFIG_DATA,
    getPayload: (basePayload) => ({
      ...basePayload,
      options: {
        limit: basePayload.page_size,
        skip: basePayload.page_size * (basePayload.page_number - 1),
      },
      filters: Object.keys(basePayload.filters).reduce((acc: any, key) => {
        acc.push({ code: key, value: basePayload.filters[key] });
        return acc;
      }, []),
    }),
  },
  // Default configuration for find-leads and any other module
  default: {
    url: '/find-leads',
    getPayload: (basePayload) => basePayload,
    rowsKey: 'results',
    errorKey: Keys.ERROR_FETCHING_CONFIG_DATA,
    // Custom metadata extractor for leads API response structure
    getMetadata: (data, pageSize, currentPage) => {
      const resultsMeta = data?.results_meta || {};
      const leadCount = resultsMeta.lead_count || 0;
      const pageNumber = resultsMeta.page_number || currentPage;
      const maxPages = Math.ceil(leadCount / pageSize) || 1;
      return {
        totalCount: leadCount,
        maxPages,
        pageSize,
        currentPage: pageNumber,
      };
    },
    // Custom columns extractor for leads API response structure
    getColumns: (data) => data?.config?.columns,
  },
};

export const MODULES_WITHOUT_ADD_BUTTON = [
  WORKFLOW_DDP_STATUS,
  BULK_ALLOCATION,
  BULK_REVOCATION,
  CRM_UPDATE_STATUS,
];

export const MODULES_WITHOUT_FILTER_SUPPORT = [
  BULK_ALLOCATION,
  BULK_REVOCATION,
  WORKFLOW_DDP_STATUS,
];
